export default __webpack_public_path__ + "static/iconography-image-g-7685e1cf6f1fa935f64ebd0f9a9d98bc65471d4807f2ee4d9ef2f6a8c40c80ba.png";